export const types = {
  OPEN_ADD_ON_MODAL: 'modules/quotes/modals/OPEN_ADD_ON_MODAL',
  CLOSE_ADD_ON_MODAL: 'modules/quotes/modals/CLOSE_ADD_ON_MODAL',

  LIVE_ADD_ON_PREVIEW_REQUEST:
    'modules/quotes/modals/LIVE_ADD_ON_PREVIEW_REQUEST',
  LIVE_ADD_ON_PREVIEW_SUCCESS:
    'modules/quotes/modals/LIVE_ADD_ON_PREVIEW_SUCCESS',
  LIVE_ADD_ON_PREVIEW_ERROR: 'modules/quotes/modals/LIVE_ADD_ON_PREVIEW_ERROR',

  RECEIVE_OVERRIDES: 'modules/quotes/modals/RECEIVE_ADD_ON_OVERRIDES',
};

export const addOnModal = {
  open: ({ cells, isReadOnly, addOn }) => {
    return {
      type: types.OPEN_ADD_ON_MODAL,
      payload: {
        cells,
        isReadOnly,
        addOn,
      },
    };
  },
  close: () => ({
    type: types.CLOSE_ADD_ON_MODAL,
  }),
  receiveOverrides: ({ nextOverrides }) => ({
    type: types.RECEIVE_OVERRIDES,
    payload: { nextOverrides },
  }),
};

export const liveAddOnPreview = {
  request: ({ addOnId, newOverrides }) => ({
    type: types.LIVE_ADD_ON_PREVIEW_REQUEST,
    payload: { addOnId, overrides: newOverrides },
  }),
  success: (addOn) => ({
    type: types.LIVE_ADD_ON_PREVIEW_SUCCESS,
    payload: addOn,
  }),
  error: () => ({
    type: types.LIVE_ADD_ON_PREVIEW_ERROR,
  }),
};
